import { TicketDto, VoidFunc } from '@trucktrax/trucktrax-ts-common';
import { SnackbarOptions } from '../../../store/actions/snackbarActions';
import { MaterialReceiptFields, ModalOptions } from '../../../types';
import {
  ACCENT,
  ARE_YOU_SURE,
  CANCEL_LABEL,
  CONFIRM_MATERIAL_RECEIVED,
  ERROR,
  MATERIAL_RECEIVED_CONFIRM_BODY,
  SUCCESS,
} from '../../../constants/appConstants';
import { MATERIAL_RECEIVED_SUCCESS } from '../../../constants/successConstants';
import { MATERIAL_RECEIVED_ERROR } from '../../../constants/errorConstants';

/**
 * DEV-4153: the acknowledge-material confirm interaction (confirm modal →
 * BE call → toast) shared by the Received column checkbox and the
 * drill-down's Mark as Received button. The store-bound pieces are injected
 * by each consumer's connect — this module must not import ticketsService or
 * featureFlagUtil (both reach Main), since it is reachable from every ticket
 * list config.
 */
export interface MaterialReceivedActionProps {
  openModal: (options: ModalOptions) => void;
  closeModal: VoidFunc;
  openSnackbar: (options: SnackbarOptions) => void;
  acknowledgeIncomingTicket: (ticketId: number) => Promise<TicketDto & MaterialReceiptFields>;
}

export const openMaterialReceivedConfirm = (
  ticketId: number,
  actions: MaterialReceivedActionProps,
) => {
  const confirmAcknowledge = async () => {
    try {
      await actions.acknowledgeIncomingTicket(ticketId);
      actions.openSnackbar({
        snackbarBody: MATERIAL_RECEIVED_SUCCESS,
        dataTest: 'material-received-success-snackbar',
        snackbarType: SUCCESS,
      });
    } catch (e: any) {
      actions.openSnackbar({
        snackbarBody: `${MATERIAL_RECEIVED_ERROR}${e?.response?.data?.message ?? e?.message ?? e}`,
        dataTest: 'material-received-error-snackbar',
        snackbarType: ERROR,
      });
    }
    actions.closeModal();
  };

  actions.openModal({
    modalType: ACCENT,
    modalTitle: ARE_YOU_SURE,
    modalBody: MATERIAL_RECEIVED_CONFIRM_BODY,
    modalOpen: true,
    acceptDialog: confirmAcknowledge,
    acceptText: CONFIRM_MATERIAL_RECEIVED,
    cancelText: CANCEL_LABEL,
    disabled: false,
    noActions: false,
  });
};
